module.exports = __webpack_public_path__ + "static/security1-fa6d30775ecbe1c2bf68e7d9b0d77f0f.png";